export const w = (d = "checkATest") => window?.[d];
export const r = () =>
  w()
    ? "abcdefghijklmnopqrstuvwxyz0123456789"[Math.floor(Math.random() * 6)]
    : crypto.getRandomValues(new Uint32Array(1))[0] % 10;

export const rs = (l) => {
  const c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const r = new Uint32Array(l);
  let s = "";
  crypto.getRandomValues(r);
  for (let i = 0; i < l; i++) {
    s += c[r[i] % c.length];
  }
  return s;
};

export const s = (v) => btoa(JSON.stringify(v));